import React from 'react';
import { Container } from 'react-bootstrap';
import './HomepageHero.css';
import Buttonfilled from '../Buttonfilled/Buttonfilled';

const HomepageHero = () => {
  return (
    <section className="hero-section">
      <div className="hero-overlay" />
      <div className="gradient-overlay" />

      <Container className="hero-content">
        <div className='hero-inner'>

          <h1 className="hero-title">
            Luxury Eyewear<span className="hero-accent"> Precision </span> Eye  <span className="hero-accent">Care</span>
          </h1>
          <p className="hero-subtitle">
            Discover designer frames, advanced lenses, and personalized eye care all under one roof. See clearly, look confident.
          </p>
          <div className="d-flex gap-3 mt-3">
            <Buttonfilled text='Book an eye exam' />
            {/* <Button as={Link} to="/services" variant="outline-light" className="hero-btn-outline">Explore Frames</Button> */}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default HomepageHero;